/* eslint-disable react/prop-types */
import React from 'react';
import classNames from '@jd/jmtd-tools/es/classnames';
import ButtonGroup from '../ButtonGroup';
import Form from '../Form';
import FormControlButton from '../FormControlButton';
import Radio from '../Radio';
export default function RadioButtonGroup(_ref, _ref2) {
  var data = _ref.data,
      isChecked = _ref.isChecked,
      select = _ref.select;
  var size = _ref2.size,
      className = _ref2.className,
      showRadio = _ref2.showRadio,
      outline = _ref2.outline,
      space = _ref2.space;
  return /*#__PURE__*/React.createElement(Form, {
    size: size,
    alignControlWidth: true
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    "data-component-name": "RadioButtonGroup",
    className: classNames(className, 'jmtd-radio-button-group', 'jmtd-form-control-button-group', {
      'jmtd-radio-button-group-space': !!space,
      'jmtd-form-control-button-group-space': !!space
    })
  }, data.map(function (_ref3) {
    var label = _ref3.label,
        value = _ref3.value,
        disabled = _ref3.disabled,
        icon = _ref3.icon;
    var checked = isChecked(value);
    return /*#__PURE__*/React.createElement(FormControlButton, {
      checked: checked,
      outline: outline,
      disabled: disabled,
      key: value,
      showControl: showRadio,
      control: /*#__PURE__*/React.createElement(Radio, {
        disabled: disabled,
        className: "jmtd-form-control-button-control",
        checked: checked,
        onChange: function onChange() {
          select(value);
        }
      }),
      icon: icon
    }, label);
  })));
}